// `crypto.randomUUID` only exists in secure contexts (HTTPS or localhost). On a plain-HTTP host it
// is undefined, and calling it inside a request interceptor would throw before the request is sent
// — breaking every API call rather than just losing a correlation id.
//
// The value is only ever used to correlate a frontend error with its backend log, so a non-crypto
// fallback is fine. Kept to [A-Za-z0-9-] and under 64 chars to satisfy the API's
// CorrelationIdMiddleware validation.
export function createCorrelationId(): string {
  try {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
  } catch {
    // Fall through to the non-crypto id below.
  }

  const random = Math.random().toString(36).slice(2, 12);
  return `${Date.now().toString(36)}-${random}`;
}
